import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { payWithRazorpay } from '../providers/razorpay.provider';
import { useCheckout, SUBSCRIPTION_STATUS } from '../CheckoutContext';
import { selectSubscription } from '../../../Redux/subscriptionSlice';

const PaymentButton = ({
  provider,
  plan,
  cycle,
  disabled,
  isValid,
  billingFormData,
  billingErrors,
  setBillingErrors,
}) => {
  const [loading, setLoading] = useState(false);
  const { setSubscriptionStatus } = useCheckout();
  const subscription = useSelector(selectSubscription);
  const isRecoveryFlow = Boolean(subscription?.paymentRecoveryRequired);

  const handlePay = () => {
    if (disabled || !isValid) return;

    setLoading(true);

    const onSuccess = ({ mode } = {}) => {
      setLoading(false);
      setSubscriptionStatus(SUBSCRIPTION_STATUS.PROCESSING);
      if (mode === 'recovery') {
        toast.info('Payment update initiated. We are confirming your subscription status.');
      }
    };

    const onError = (error) => {
      setLoading(false);
      const message = error?.message || 'Payment failed. Please try again.';
      toast.error(message);
    };

    payWithRazorpay({
      plan,
      cycle,
      billing: billingFormData,
      onSuccess,
      onError,
    });
  };

  return (
    <button
      type="button"
      onClick={handlePay}
      disabled={!isValid || loading}
      className="w-full bg-black text-white py-3 rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-800 transition"
    >
      {loading
        ? 'Opening secure payment...'
        : isRecoveryFlow
        ? 'Fix payment method'
        : 'Proceed to pay'}
    </button>
  );
};

export default PaymentButton;
